<template>
  <div
    class="flex-grow overflow-y-scroll h-0 text-white"
    @scroll="scrollingOnSnapshotsArea"
    ref="snapshotArea"
  >
    <!-- Snapshots list -->
    <div class="flex flex-col max-h-full w-full">
      <div class="p-4 mb-5">
        <SnapshotMessage
          v-for="snapshot in snapshots"
          :key="snapshot.id"
          :snapshot-data="snapshot"
          :clinicianName="clinicianName"
          :user-id="userId"
          @removeSnapshot="$emit('removeSnapshot', $event)"
        />
        <div v-if="isEmpty" class="text-gray-500 text-center">No snapshots</div>
      </div>
    </div>
  </div>
</template>

<script>
import SnapshotMessage from '@/Components/Chat/SnapshotMessage.vue';

export default {
  props: {
    snapshots: {
      required: false,
    },
    userId: {
      required: true,
    },
    clinicianName: {
      type: String,
    },
  },
  components: { SnapshotMessage },
  computed: {
    isEmpty() {
      return this.snapshots.length === 0;
    },
  },
  mounted() {
    this.scrollToLastSnapshot(true);
  },
  data() {
    return {
      userIsScrolling: false,
      showNewSnapshotsIndicator: false,
    };
  },

  watch: {
    snapshots: {
      deep: true,
      handler() {
        this.scrollToLastSnapshot();
      },
    },
  },
  methods: {
    scrollingOnSnapshotsArea(event) {
      const posFromBottom =
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      this.userIsScrolling = posFromBottom > 200;
      if (posFromBottom < 20) {
        this.showNewSnapshotsIndicator = false;
      }
    },

    scrollToLastSnapshot(forced = false) {
      const snapshotArea = this.$refs.snapshotArea;
      if (!snapshotArea) return;

      if (!this.userIsScrolling || forced) {
        snapshotArea.scrollTo({
          top: snapshotArea.scrollHeight,
          behavior: 'smooth',
        });
        setTimeout(() => {
          snapshotArea.scrollTo({
            top: snapshotArea.scrollHeight,
            behavior: 'smooth',
          });
          this.showNewSnapshotsIndicator = false;
        }, 300);
      } else {
        this.showNewSnapshotsIndicator = true;
      }
    },
  },
};
</script>

<style></style>
